import { render, staticRenderFns } from "./BronchopneumoniaScoreAttachmentsTable.vue?vue&type=template&id=38e95b94&scoped=true&"
import script from "./BronchopneumoniaScoreAttachmentsTable.vue?vue&type=script&lang=ts&"
export * from "./BronchopneumoniaScoreAttachmentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./BronchopneumoniaScoreAttachmentsTable.vue?vue&type=style&index=0&id=38e95b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e95b94",
  null
  
)

export default component.exports